const storageFallback = () => {
  try {
    localStorage.setItem("_storage_test", "test");
    localStorage.removeItem("_storage_test");
  } catch (exc) {
    let tmpStorage = {};
    const prefix = "__feedback__"; // Prefix all keys to avoid matching built-ins
    Storage.prototype.setItem = (k: string, v: any) => (tmpStorage[prefix + k] = v);

    Storage.prototype.getItem = (k: string) =>
      typeof tmpStorage[prefix + k] === "undefined" ? null : tmpStorage[prefix + k];
    Storage.prototype.removeItem = (k: string) => (tmpStorage[prefix + k] = undefined);
    Storage.prototype.clear = () => (tmpStorage = {});
  }
};

export default storageFallback;
